/**
 * Button for redirection to the wallet scan
 */
interface IScanButtonProps{
  chain: string
  wallet: string
}

const ScanButton = ({chain, wallet} : IScanButtonProps) => {
  console.log(chain); // TODO: remove when tested
  // const scan = Network.fromDex(exchange).getScanForWallet();
  const scan = 'placeholder';   // TODO: Network.fromName()
  /**
   * 1st group matches address ending with .io
   * 2nd one -- .com
  */
  const nameMatch = scan.match(/\/\/(.*)\b.io|\/\/(.*)\b.com/);
  if (nameMatch && nameMatch.length > 0) {
    const [
      _address, group1, group2
    ] = nameMatch;
    return <a className='wallet_modal__pill wallet_modal__scan' href={`${scan}${wallet}`} target="_blank" rel="noreferrer">{group1 || group2}</a>;
  }
  return null;
};

export default ScanButton;